import React, { useEffect, useState } from "react";
import { useStore } from "effector-react";
import { Redirect } from "react-router-dom";
import { Form } from "react-bootstrap";
import { Preloader } from "../../../common/ui/Preloader/preloader";
import { loggedIn } from "../../login/logics/reg";
import { $companies, queryCompanies } from "../../../common/companies2";
import { NewAccountElseCompanyBlock } from "./NewAccountElseCompaniesBlock";
import { NewAccountKrkBlock } from "./NewAccountKrkBlock";
import { pathLogin } from "../../../common/config/vars";

import "../../login/style/Login.css";
import "../styles/NewAccountKrkBlock.css";

import "../../../../node_modules/react-toastify/dist/ReactToastify.css";
import { $SiteColors } from "../../../common/config/company-atts";
import { getCustomUserAgent, getCustomUserAgentASB } from "../../../common/customUserAgent";

//export const addAccountCanceled = createEvent();

/*const isCalledFromLogin = () => {
  let ref = document.referrer
  console.log("gg:", ref, document.location.origin + pathLogin)
  return ref == document.location.origin + pathLogin
} */

interface INewAccountMainBlock {
  goTo?: number; //указываем то, куда перейти после завершения или отмены добавления аккаунта(учитывается если redirectTo или redirectToOnCancel отсутствуют)
  redirectTo?: string; //переходим по этому адресу в случае успешного результата
  hideKrkAnon?: boolean;
  clearDataOnCancel?: boolean;
}

export const NewAccountMainBlock = ({
  redirectTo = "",
  goTo = -1,
  hideKrkAnon = true,
  clearDataOnCancel,
}: INewAccountMainBlock) => {
  const [comid, setComid] = useState(""); //идентификатор компании, по которому добавляется аккаунт
  const [loaded, setLoaded] = useState(false);
  //const [hideAnon, _] = useState((ignoreReferrer && hideKrkAnon) || (!ignoreReferrer && isCalledFromLogin()))
  const companiesAnalog =  useStore($companies); //список компании
  const companies =  getCustomUserAgent()===getCustomUserAgentASB()?[{id: "56",name: "Автоспецбаза"}]: companiesAnalog;
  useEffect(() => {
    queryCompanies().then(() => setLoaded(true)); //загружаем список компаний
  }, []);

  useEffect(() => {
    if (companies.length > 0) {
      //если список компаний не пуст, то по умолчанию выбираем первую компанию
      console.log(companies)
      console.log(companies[0].id.toString())
      setComid(companies[0].id.toString());
    }
  }, [companies]);

  const getComAddAccBlock = (comid: string) => { 
  
    if (comid === "34"||comid === "56")
      return (
        <NewAccountKrkBlock
          comid={comid}
          goTo={goTo}
          redirectTo={redirectTo}
          hideAnon={hideKrkAnon}
          clearDataOnCancel={clearDataOnCancel}
        />
      );
    return (
      <NewAccountElseCompanyBlock
        comid={comid}
        goTo={goTo}
        redirectTo={redirectTo}
        clearDataOnCancel={clearDataOnCancel}
      />
    );
  };

  if (!loggedIn()) {
    console.log("LOGGED_IN:", loggedIn() )
    return <Redirect to={pathLogin} />;
  } else
    return (
      <div className="login" style={{backgroundColor:$SiteColors.getState().backgroundColor}}>
        <div className="login__container"  style={{backgroundColor:$SiteColors.getState().cardColor}}>
          <h3 className="login__title">Добавление лицевого счета</h3>
          {loaded && (
            <>
              <Form.Control
                as="select"
                className="login__input login__select"
                id="sell"
                value={comid}
                onChange={(e) => setComid(e.target.value)}
                custom
              >
                {companies.map((c, i) => {
                  return (
                    <option value={c.id} id={c.id} key={i}>
                      {c.name}
                    </option>
                  );
                })}
              </Form.Control>
              {comid !== "" ? (
               
                getComAddAccBlock(comid)
              ) : (
                <p className="login__status login__status_error">
                  Не удалось найти блок добавления аккаунта
                </p>
              )}
            </>
          )}
          {!loaded && <Preloader small={false} />}
        </div>
      </div>
    );
};
